module.exports = __webpack_public_path__ + "static/media/hero-use-case-one.908e2810.jpg";